<mat-chip-list *ngIf="dashboardElement.details.length === 0" >
  <mat-chip class="location" style="margin-left:26px">
    <fa-icon class="noteElement"
             [ngClass]="getClassByNote()"
             [icon]="getIconStatus()"></fa-icon>&nbsp;&nbsp; {{dashboardElement?.result}}
  </mat-chip>
</mat-chip-list>


<mat-expansion-panel *ngIf="dashboardElement.details.length !== 0" [ngbTooltip]="'SHOW_DETAILS' | translate"
                     placement="right">
  <mat-expansion-panel-header>
    <mat-chip-list>
      <mat-chip class="location">
        <fa-icon class="noteElement"
                 [ngClass]="getClassByNote()"
                 [icon]="getIconStatus()"></fa-icon>&nbsp;&nbsp; {{dashboardElement?.result}}
      </mat-chip>
    </mat-chip-list>&nbsp;&nbsp;
  </mat-expansion-panel-header>
  <div class="detailElementContainer">
    <table style="width: 100%">
      <thead>
      <tr>
        <th class="detailElement header">{{'LOCATION' | translate}}</th>
        <th class="detailElement header">{{'COUNT' | translate}}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor=" let detail of  dashboardElement?.details;let i = index" [ngClass]="i%2 ? 'row-pair' : 'row-unpair'">
        <td class="detailElement"><div class="detailId">{{detail?.location}}</div> {{detail?.locationName}} </td>
        <td class="detailCount">{{ detail?.count}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</mat-expansion-panel>



